import './Footer.css'

const Footer = () => (
  <footer>
    <a href='https://github.com/rajshekhar26/cleanfolio' className='link'>
      Copyright © John
    </a>
  </footer>
)

export default Footer
